import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ReviewsHamburgerIcon from 'assets/ReviewsHamburgerIcon.svg';
import defaultUserAvatar from 'assets/user_avatar.svg';

import { ROUTES } from 'routes/route.constants';

import { logoutUser } from 'utlis/globalFunctions';

const DashboardHeader = ({ onCreateReviewToggle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authUser = useSelector(state => state.userStore);

  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem('userObject');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('authenticated');

    logoutUser(dispatch, navigate);
    navigate(ROUTES.WEB_LOGIN);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const onClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', onClickOutside);

    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const handleNewReview = () => {
    onCreateReviewToggle(true);
  };

  return (
    <header className="border-b border-gray-200 px-[16px] py-3">
      <div className="flex items-center justify-between h-10">
        {/* Left: logo/title */}
        <div className="flex items-center space-x-4">
          <h1 className="font-inter text-sm font-medium text-figma-gray-900 leading-5">
            Dashboard
          </h1>
        </div>

        {/* Right: help, menu button, avatar dropdown */}
        <div className="flex items-center space-x-4">
          <button
            onClick={handleNewReview}
            className="flex items-center justify-center px-3 py-2 bg-primary-500 text-white font-inter
            text-sm font-medium rounded-lg shadow-shadow-xs hover:bg-primary-600 transition-colors"
          >
            New review
          </button>

          {/* Avatar + dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setMenuOpen(dashboardNavbarMenuOpen => !dashboardNavbarMenuOpen)}
              className="flex items-center gap-16 py-1 pl-2 pr-1 border border-gray-200 rounded-full
              focus:outline-none hover:border-gray-300"
            >
              {/* Hamburger icon */}
              <img src={ReviewsHamburgerIcon} alt="Menu" width={20} height={20} />

              {/* Avatar */}
              <div className="h-8 w-8 overflow-hidden rounded-full flex items-center justify-center bg-gray-100">
                <img
                  src={authUser?.profile_photo || defaultUserAvatar}
                  alt="User Avatar"
                  className="h-6 w-6 rounded-full"
                />
              </div>
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-16 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
                >
                  Log Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

DashboardHeader.propTypes = {
  onCreateReviewToggle: PropTypes.func.isRequired,
};

export default DashboardHeader;
